// extracted by mini-css-extract-plugin
export default {"root":"IconWebsite_root__VtXee"};